module.exports = require('./helpers/bundle-url').getBundleURL('Fa2tF') + "loader_hv.3a97456d.gif";